// src/Footer.js
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsArrowUp } from "react-icons/bs";

const Footer = () => {
    const [visible, setVisible] = useState(false);
    const { t } = useTranslation();

    const handleScroll = () => {
        if (window.scrollY > 500) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };
    
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <>
            <footer className="ar_footer_area_section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="ar_footer_area_logo">
                                <div className="ar_ooter_logo">
                                    <a href="/"><img src="/images/game-ui/footerLogo.png" alt="images" /></a>
                                </div>
                                <div className="ar_footer_social_icon">
                                    <h2>{t('stayConnected')}</h2>
                                    <div className="ar_footer_icon">
                                        <a href="#"><i className="fa-brands fa-discord"></i></a>
                                        <a href="#"><i className="fa-brands fa-youtube"></i></a>
                                        <a href="#"><i className="fa-brands fa-square-facebook"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ar_footer_area_cont">
                                <h2>{t('disclaimer')}</h2>
                                <p>{t('disclaimerText')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {visible && <button className="scrolltotop" onClick={scrollToTop}>
                <BsArrowUp />
            </button>}
        </>
    );
};

export default Footer;